import { OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
var CallTranscriptComponent = /** @class */ (function () {
    function CallTranscriptComponent(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.transcriptLines = [];
        this.isDialpad = false;
    }
    CallTranscriptComponent.prototype.ngOnInit = function () {
        if (this.isDialpad) {
            this.transcriptLines = this.parseDialpadSegments(this.data);
            return;
        }
        if (!this.data)
            return;
        var rawLines = this.data.split('\n');
        for (var _i = 0, rawLines_1 = rawLines; _i < rawLines_1.length; _i++) {
            var line = rawLines_1[_i];
            line = line.trim();
            if (!line) {
                continue;
            }
            if (line.startsWith('User:')) {
                this.transcriptLines.push({
                    speaker: 'User',
                    text: line.substring(5).trim()
                });
            }
            else if (line.startsWith('Agent:')) {
                this.transcriptLines.push({
                    speaker: 'Agent',
                    text: line.substring(6).trim()
                });
            }
            else {
                this.transcriptLines.push({
                    speaker: '',
                    text: line
                });
            }
        }
    };
    // Dialpad transcript is a JSON string: [{speaker, text}, ...] (or legacy { "Speaker": "text" })
    CallTranscriptComponent.prototype.parseDialpadSegments = function (raw) {
        var lines = [];
        if (!raw) {
            return lines;
        }
        var parsed;
        try {
            parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        }
        catch (e) {
            // plain text shape: "Speaker : text" per line
            return this.parsePlainTranscript(String(raw));
        }
        if (Array.isArray(parsed)) {
            for (var _i = 0, parsed_1 = parsed; _i < parsed_1.length; _i++) {
                var item = parsed_1[_i];
                if (item && item.speaker !== undefined && item.text !== undefined && item.text !== null) {
                    lines.push({ speaker: String(item.speaker), text: String(item.text) });
                }
            }
        }
        else if (parsed && typeof parsed === 'object') {
            // legacy shape: { "Speaker": "text" }
            Object.keys(parsed).forEach(function (speaker) {
                var text = parsed[speaker];
                if (text !== null && text !== undefined && typeof text !== 'object') {
                    lines.push({ speaker: speaker, text: String(text) });
                }
            });
        }
        return lines;
    };
    CallTranscriptComponent.prototype.parsePlainTranscript = function (raw) {
        var lines = [];
        raw.split('\n').forEach(function (line) {
            line = line.trim();
            if (!line) {
                return;
            }
            var idx = line.indexOf(' : ');
            if (idx > -1 && !line.startsWith('=')) {
                lines.push({ speaker: line.substring(0, idx).trim(), text: line.substring(idx + 3).trim() });
            }
            else {
                lines.push({ speaker: '', text: line });
            }
        });
        return lines;
    };
    CallTranscriptComponent.prototype.closePanel = function () {
        this.bsModalRef.hide();
        if (this.onClose) {
            this.onClose.next('close');
            this.onClose.complete();
        }
    };
    return CallTranscriptComponent;
}());
export { CallTranscriptComponent };
